module.exports = __webpack_public_path__ + "static/media/property_alert.7837239c.png";